<template>
  <div>
    <navigation-drawer :titles="'لیست دسته بندی پایگاه دانش'"/>
    <div class="container">
      <div class="row ">
        <div class="col-12">
          <v-text-field
              v-model="search"
              append-icon="fa-search"
              class="input-border mb-1"
              label="جستجو"
              single-line
              solo></v-text-field>
          <v-data-table
              id="dataTable"
              :expanded.sync="expanded"
              show-expand
              :single-expand="singleExpand"
              :headers="headers"
              :items="list"
              :items-per-page="10"
              :light="true"
              :mobile-breakpoint="767"
              :search="search"
              class="data-table"
              fixed-header
              item-key="KnowledgeCategoryId"
          >
            <template v-slot:[`item.Counter`]="{ index }">
              <div>{{ index + 1 }}</div>
            </template>

            <template v-slot:[`item.FileUrl`]="{ item }">
              <v-img v-if="item.FileUrl != null" :src="$replaceHttps(item.FileUrl)" height="130"
                     width="130" contain>
              </v-img>
            </template>

            <template v-slot:[`item.action`]="{ item }">
              <v-btn solo elevation="0" color="primary" class="" @click="editTicket(item.KnowledgeCategoryId)">
                <i class="fas fa-edit"></i>
              </v-btn>
            </template>
            <template v-slot:expanded-item="{ item }">
              <td>
                <div v-if="item.Description === ''">
                  بدون توضیح
                </div>
                <div v-else>
                  <div v-html="item.Description"></div>
                </div>
              </td>
            </template>
            <template v-slot:[`item.IsActive`]="{ item }">
              <td>
                <div v-if="item.IsActive === true">
                  بله
                </div>
                <div v-else>
                  خیر
                </div>
              </td>
            </template>
          </v-data-table>
        </div>
      </div>
    </div>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import NavigationDrawer from "@/Admin/components/navigationDrawer";

export default {
  name: "listKnowledgeCategory",
  components: {NavigationDrawer},
  data: () => ({
    search: null,
    expanded: [],
    singleExpand: true,
    showLoaderDialog: false,
    headers: [
      {text: 'ردیف', value: 'Counter', sortable: false,},
      {text: 'عکس', value: 'FileUrl', sortable: false,},
      {text: 'نام', value: 'Name', sortable: false,},
      {text: 'توضیحات', value: 'data-table-expand', sortable: false,},
      {text: 'فعال', value: 'IsActive', sortable: false,},
      {text: '', value: 'action', sortable: false,},
    ],
    list: [],
    src: 'logo2.png'
  }),
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Admin/KnowledgeCategoriesList", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.list = JSON.parse(result)
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    editTicket(id) {
      this.$router.push({path: 'KnowledgeCategory', query: {id: id}})
    }
  }
}
</script>

<style scoped>

</style>